const $form = $('.js-form')

$form.submit(function(e) {
    const email = $form.find('input[name=email]').val()
		const message = $form.find('textarea[name="message"]').val()
		const recaptcha = $form.find('textarea[name="g-recaptcha-response"]').val()
		const agree = $form.find('input[name="agree"]').prop('checked')

		e.preventDefault()

    if(!email){
    	alert('Zadejte email!')

    	$form.find('input[name=email]').focus()
    	return false;
    }else if(!validateEmail(email)){
    	alert('Zadejte správný email!')

    	$form.find('input[name=email]').focus()
    	return false;
    }else if(!message){
    	alert('Zpráva je povinná!')
    	$form.find('textarea[name="message"]').focus()
    	return false;
    }else if(!agree){
    	alert('Je potřeba souhlasit se zpracováním osobních údajů.')
    	return false;
    }else if(!recaptcha){
    	alert('Prosím dokažte, že nejste robot.')
    	return false;
    }

    this.submit();
});

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
